import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-validar-transacciones',
  templateUrl: './validar-transacciones.component.html',
  styleUrls: ['./validar-transacciones.component.scss'],
})
export class ValidarTransaccionesComponent implements OnInit {
  form: FormGroup;

  @Input() data: { task: any };

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    const { task } = this.data;
    console.log(task);
    const values = task.data ? task.data : null;
    this.form = this.fb.group({
      autorizar: [values ? values.autorizar : false, [Validators.required]],
      patronFraude: [
        values ? values.patronFraude : false,
        [Validators.required],
      ],
    });
  }
  verificateInput(value: string) {
    return (
      this.form.get(value)?.invalid &&
      (this.form.get(value)?.dirty || this.form.get(value)?.touched)
    );
  }
}
